import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'cnxlcc_steps';
export const route = 'cnxlcc_steps/[[...params]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "cnxlcc_steps" */
/* webpackPrefetch: true */
'../components/StepsLCCPage')));